module.exports = __webpack_public_path__ + "img/Type_Rock.2be2c755.png";